import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { PAGE_SELECT_OPTIONS } from '../../../../../utils/params/helpers'

const PageSelect = ({ value, onChange, isSmallSize }) => {
	const { t } = useTranslation('common')

	return (
		<Box>
			<FormControl fullWidth size={isSmallSize ? 'small' : 'medium'}>
				<InputLabel id="path-select-label">{t('common:input.page')}</InputLabel>
				<Select
					labelId="path-select-label"
					id="path-select"
					value={value || ''}
					label={t('common:input.page')}
					name="path"
					onChange={onChange}
				>
					<MenuItem value="">Empty</MenuItem>
					{PAGE_SELECT_OPTIONS.map((menu) => (
						<MenuItem value={menu?.page?.path} key={menu?.page?.path}>
							{menu.name}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</Box>
	)
}

export default PageSelect
